module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _vm._l((_vm.itemList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "you__menu display-flex justify-space-between align-center my-3",
      on: {
        "click": function () { return item.handle(); }
      }
    }, [_c('div', {
      staticClass: "relative you__menu__icon"
    }, [(item.number > 0) ? _c('div', {
      staticClass: "absolute you__menu__icon--number display-flex justify-center align-center text-dmsans-12"
    }, [_vm._v("\n        " + _vm._s(item.number) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": item.icon
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "you__menu--title"
    }, [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('div', {
      staticClass: "w-22"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }), _vm._v(" "), _c('Footer')], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative mb-5"
  }, [_c('div', [_c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/you.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "absolute you__username"
  }, [_c('div', {
    staticClass: "you__username__name"
  }, [_c('span', [_vm._v(" Salva ")]), _vm._v(" "), _c('img', {
    staticClass: "max-full-width",
    attrs: {
      "src": require("../../assets/mobile/icon/check-circle.svg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "you__username__type"
  }, [_vm._v("ACCOUNT")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6be242c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/you.vue
// module id = 1858
// module chunks = 180